export const StateConstant = {
    NONE: 'NONE',
    DRAFT: 'DRAFT',   
    FINAL: 'FINAL'
}